import Navigation from "./Navigation";
import {useNavigationContext} from "../context/NavigationContext";

const AppLayout = (props) => {
    const { containerClassnames } = props;
    // const {navigationVisibility} = useNavigationContext()


    return (
        <div id="app-container" className={containerClassnames}>
            <main >
                {props.children}
            </main>
            <Navigation />
        </div>
    );

};
export default AppLayout;
